import React, { useState } from "react";
import BrochureForm from "../components/EnquiryForm"; // The pop-up form
import './mcaPageStyles.css';
import Navbar from "../components/navbar";
import Footer from "../components/Footer";
import CTAButtons from "../components/sticky-button";
import PageHeader from "../about/PageHeader";
import ContactAdmissionsStrip from '../components/ContactAdmissionsStrip';

const MCAadmission = () => {
  // State to manage active tab.
  const [activeTab, setActiveTab] = useState('introduction');
  const [showForm, setShowForm] = useState(false); return (
    <>
      <Navbar />
      <CTAButtons />
      <PageHeader
        title="MCA for working professionals"
        crumbs={[{ label: 'Home', href: '/' }, { label: 'MCA for working professionals' }]}
      />
      {showForm && <BrochureForm setShowForm={setShowForm} />}
      <div className="mca-ig-wrapper ">
        {/* Navigation Tabs */}
        <div className="mca-nav-container">
          <div className={`mca-nav-item ${activeTab === 'introduction' ? 'mca-active' : ''}`} onClick={() => setActiveTab('introduction')}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"></path><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"></path></svg>
            <span>Introduction</span>
          </div>

          <div className={`mca-nav-item ${activeTab === 'eligibility' ? 'mca-active' : ''}`} onClick={() => setActiveTab('eligibility')}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
            <span>Eligibility Criteria</span>
          </div>

          <div className={`mca-nav-item ${activeTab === 'documents' ? 'mca-active' : ''}`} onClick={() => setActiveTab('documents')}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="16" y1="13" x2="8" y2="13"></line><line x1="16" y1="17" x2="8" y2="17"></line></svg>
            <span>Documents Required</span>
          </div>

          <div className={`mca-nav-item ${activeTab === 'admission-procedure' ? 'mca-active' : ''}`} onClick={() => setActiveTab('admission-procedure')}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M9 11l3 3L22 4"></path><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"></path></svg>
            <span>Admission Procedure</span>
          </div>

          <div className={`mca-nav-item ${activeTab === 'fees-details' ? 'mca-active' : ''}`} onClick={() => setActiveTab('fees-details')}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><path d="M16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8"></path><line x1="12" y1="16" x2="12" y2="18"></line><line x1="12" y1="6" x2="12" y2="8"></line></svg>
            <span>Fees Details<br /><span style={{ fontSize: '9px', opacity: 0.8 }}>(शुल्क विवरण)</span></span>
          </div>

          <div className={`mca-nav-item ${activeTab === 'mode-of-payment' ? 'mca-active' : ''}`} onClick={() => setActiveTab('mode-of-payment')}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="1" y="4" width="22" height="16" rx="2" ry="2"></rect><line x1="1" y1="10" x2="23" y2="10"></line></svg>
            <span>Mode of Payment</span>
          </div>
        </div>

        {/* Main Content Card */}
        <div className="mca-main-card">

          {/* --- TAB 1: INTRODUCTION --- */}
          {activeTab === 'introduction' && (
            <>
              <div className="mca-header">
                <div className="mca-info-icon-wrapper">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
                    <line x1="3" y1="9" x2="21" y2="9"></line>
                    <path d="M9 21v-6a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v6"></path>
                  </svg>
                </div>
                <div className="mca-title">MCA Working Professional</div>
              </div>

              <div className="mca-intro-stats-row">
                <div className="mca-intro-stat-card">
                  <span className="mca-intro-stat-icon">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                      <circle cx="9" cy="7" r="4"></circle>
                      <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                      <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                    </svg>
                  </span>
                  <span className="mca-intro-stat-label">Intake</span>
                  <span className="mca-intro-stat-value">60 Seats</span>
                </div>
              </div>

              <p className="mca-intro-text-block">
                Working Professional” means professionals working in Registered industry or Organization (Central or State) or Private or Public Limited Company or MSMEs having one year experience. TIMSCDR offer  MCA Working Professional course with intake of 60 seats.
              </p>
            </>
          )}

          {/* --- TAB 2: ELIGIBILITY CRITERIA --- */}
          {activeTab === 'eligibility' && (
            <>
              <div className="mca-header">
                <div className="mca-info-icon-wrapper">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="mca-info-icon">
                    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                    <polyline points="22 4 12 14.01 9 11.01"></polyline>
                  </svg>
                </div>
                <div className="mca-title">Eligibility Criteria</div>
              </div>

              <div className="mca-elig-grid">
                <div className="mca-elig-column" style={{ width: '100%' }}>
                  <div className="mca-elig-header-row">
                    <span className="mca-step-badge-solid">1</span>
                    <h5 className="mca-elig-main-title">Admission to the First Year of Professional Education Post Graduate Courses for MCA working Professional for the academic year 2026-27</h5>
                  </div>
                  <div className="mca-elig-card">
                    <p style={{ marginBottom: "10px", marginTop: "10px", fontSize: "0.95rem" }}>The candidate should fulfill the following eligibility criteria:</p>
                    <ul className="mca-elig-list">
                      {[
                        "The candidate should be a citizen of India;",
                        "should have passed any graduation degree (e.g.: B.E. or B.Tech. or B.Sc or B.Com. or B.A. or B. Voc. or BCA etc.,) preferably with Mathematics at 10+2 level or at Graduation level and obtained at least fifty per cent marks (at least forty-five per cent. in case of candidates of Reserved Categories, Economically Weaker Section and Persons with Disability category belonging to the Maharashtra State) in the qualifying examination."
                      ].map((text, idx) => (
                        <li key={idx} className="mca-elig-item">
                          <span className="mca-list-num">{idx + 1}</span>
                          <span dangerouslySetInnerHTML={{ __html: text }}></span>
                        </li>
                      ))}
                    </ul>

                    <div className="mca-card-divider"></div>

                    <p style={{ marginBottom: "10px", marginTop: "10px", fontSize: "0.95rem", fontWeight: 600 }}>
                      In addition to qualification and eligibility for candidates eligible for respective Professional Education Post Graduate Courses Candidate shall have the following additional requirements for admission to courses for working professionals, namely: –
                    </p>

                    <ul className="mca-elig-list">
                      {[
                        "The candidate shall be working professional in Registered Industry or Organization (Central or State) or Private or Public Limited Company or Micro Small and Medium Enterprises (MSME’s) located within fifty kilo meter radial distance from the Institute.",
                        "The candidate shall have Minimum of one Year Full time or Regular working Experience in Registered Industry or Organization (Central or State) or Private or Public Limited Company or Micro Small and Medium Enterprises (MSME’s).",
                        "The Course Duration shall be as decided by the affiliating university or Autonomous Institute or University.",
                        "The timings for conduct of classes normally shall be in the evening hours/any flexible convenient timings in alignment with timings of Industry or Organization (Central or State) or Private or Public Limited Company or Micro Small and Medium Enterprises (MSME’s).",
                        "The mode of Conduct of Classes shall be as applicable for Regular Programs as defined in the AICTE Public Notice Vide. No. AICTE/AB/Academic/2020-21, dated 13th August, 2020(In Regular Face to Face Mode).",
                        "Minimum admission required to run the course shall be 1/3 of the approved intake in each course.",
                        "One seat in every Institute shall be Reserved for Candidates working in the Central Government Organizations or Industries or Companies or Autonomous Organizations purely on MERIT Basis. In absence of any such Candidate, the vacant seat shall be transferred to General Category.",
                        "Working Professionals provisionally admitted in a course of the institute where total admissions in a course are less than 1/3 rd of approved intake of the course after pre cut-off date for admissions shall be transferred strictly on merit basis in the nearby institute within 50 kilo meter radial distance from the working industry or organization in the same course or different course in case vacancy exists in nearby institutes on the request of the candidate.",
                        "Provisional Admission of the candidate shall be cancelled automatically if the candidate is not able to secure the admission on merit against vacancy in other institutes.",
                        "This process of transfer shall be carried out between Pre cut-off date and cut-off date for admissions to working professionals.",
                        "Institute having admissions below 1/3 rd admissions after Pre cut-off date has to refund full fees to the candidate in case of cancellation/transfer of admission immediately within two days of cancellation or transfer of admission.",
                        "Any other eligibility criteria or requirements declared from time to time by the appropriate authority and AICTE as defined under the Act."
                      ].map((text, idx) => (
                        <li key={idx} className="mca-elig-item">
                          <span className="mca-list-num">{idx + 1}</span>
                          <span dangerouslySetInnerHTML={{ __html: text }}></span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            </>
          )}

          {/* --- TAB 3: DOCUMENTS REQUIRED --- */}
        {activeTab === 'documents' && (
            <>
              <div className="mca-header">
                <div className="mca-info-icon-wrapper">
                  <span className="mca-info-icon">
                    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M22 10v6M2 10l10-5 10 5-10 5z"></path>
                      <path d="M6 12v5c3 3 9 3 12 0v-5"></path>
                    </svg>
                  </span>
                </div>
                <div className="mca-title">Documents Required</div>
              </div>

              <div className="mca-docs-grid">
                <div className="mca-doc-column">
                  <div className="mca-doc-col-header">
                    <span className="mca-col-icon">
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                        <polyline points="14 2 14 8 20 8"></polyline>
                        <line x1="16" y1="13" x2="8" y2="13"></line>
                        <line x1="16" y1="17" x2="8" y2="17"></line>
                        <polyline points="10 9 9 9 8 9"></polyline>
                      </svg>
                    </span>
                    List of Photocopies of Certificates to be submitted:
                  </div>
                  <ul className="mca-doc-list">
                    {[
                      "MAH-MCA-CET 2026 score card.",
                      "SC Verification letter",
                      "Institute Seat Allotment Letter from the CET CELL (if applicable)",
                      "CET Admission Freeze/ Confirmation letter",
                      "Experience Certificate for Working Professional Candidate from employer that certifies candidate have Minimum of ONE Year Full time / Regular working Experience. (proforma-W1)",
                      "Declaration from Working Professional candidate regarding Industry / Organization (Central / State) / Private / Public Limited Company / MSMEs is located within 50 KM radial distance from the admitting Institute; and regarding Reallocation process (proforma-W2)",
                      "Identification proof",
                      "Statement of marks & certificate of SSC, HSC, and Graduation (all semester/year)",
                      "Migration and Provisional Passing Certificate for those candidates who passed from any University other than the University of Mumbai.",
                      "Certificate of Indian Nationality (School Leaving Certificate indicating the Nationality of the candidate as ‘Indian’/ Valid Indian Passport/ Birth Certificate of the candidate indicating the place of birth in India.)",
                      "Domicile Certificate (if applicable), clearly indicating the place of permanent residence of the candidate or father or mother or husband.",
                      "Aadhaar Card and PAN Card Copy",
                      "ABC ID Number (APAR) Copy",
                      "Declaration of the Candidate for the Hindi Linguistic Minority Community or Leaving Certificate having information pertaining to Mother tongue Hindi (Minority Candidates)",
                      "Caste/Tribe Validity Certificate (if applicable)",
                      "Non-Creamy Layer Certificate valid up to 31 March 2027 (if applicable).",
                      "Certificates in Proforma A, B1, B2, C, D, E, G1, G2, J, K, L, M, O, U, V, W1 & W2 as applicable (Mentioned in DTE/CET cell brochure)",
                      "Any other relevant document"
                    ].map((item, idx) => (
                      <li key={idx} className="mca-doc-item">
                        <span className="mca-icon-check">
                          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                            <polyline points="22 4 12 14.01 9 11.01"></polyline>
                          </svg>
                        </span>
                        {item}
                      </li>
                    ))}
                  </ul>
                </div>

                <div className="mca-doc-column">
                  <div className="mca-doc-col-header">
                    <span className="mca-col-icon">
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                        <polyline points="14 2 14 8 20 8"></polyline>
                        <line x1="16" y1="13" x2="8" y2="13"></line>
                        <line x1="16" y1="17" x2="8" y2="17"></line>
                        <polyline points="10 9 9 9 8 9"></polyline>
                      </svg>
                    </span>
                    After verification, if provisionally confirmed in the Institute, candidate has to submit the following documents:
                  </div>
                  <ul className="mca-doc-list">
                    {[
                      "All original certificates mentioned above with attested photocopies of the same.",
                      "Affidavit for Minority Status on a ₹100/- non-judicial stamp paper in institute specified format (only for Linguistic Minority candidates).",
                      "Gap Certificate for the break after completion of Graduation examination on a ₹100/- non-judicial stamp paper in institute specified format (if applicable).",
                      "Anti ragging reference no. copy.",
                      "Physical Fitness Certificate from a registered Medical Practitioner.",
                      "Five recent passport size colour photographs.",
                      "Any other relevant document."
                    ].map((item, idx) => (
                      <li key={idx} className="mca-doc-item">
                        <span className="mca-icon-check">
                          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg>
                        </span>
                        {item}
                      </li>
                    ))}
                  </ul>
                  <div className="mca-info-text mt-3">
                    <span style={{ color: '#5a4ad1', marginRight: '8px' }}>For more information about Admission, log on: <a href="https://cetcell.mahacet.org" target="_blank" rel="noopener noreferrer" style={{ color: '#5a4ad1' }}>https://cetcell.mahacet.org</a></span>
                  </div>
                </div>
              </div>
            </>
          )}

          {/* --- TAB 4: ADMISSION PROCEDURE --- */}
          {activeTab === 'admission-procedure' && (
            <>
              <div className="mca-header">
                <div className="mca-info-icon-wrapper">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="mca-info-icon">
                    <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"></path>
                    <rect x="8" y="2" width="8" height="4" rx="1" ry="1"></rect>
                    <path d="M9 14h6"></path>
                    <path d="M9 10h6"></path>
                    <path d="M9 18h6"></path>
                  </svg>
                </div>
                <div className="mca-title">Admission Procedure</div>
              </div>

              <p className="mca-text-content">
                Admissions for the MCA Working Professional program are conducted as per the norms of the Admission Regulatory Authority (ARA) and the MH-CET Cell under the Directorate of Technical Education (DTE), Government of Maharashtra (GoM). The rules and regulations prescribed by the All India Council for Technical Education (AICTE), Government of Maharashtra, DTE Maharashtra, and the University of Mumbai are strictly followed. Admissions are based on the eligibility criteria and merit in the respective entrance examinations. All admissions are carried out according to the schedule published in leading newspapers and on the MH-CET cell website.
              </p>

              <h3 className="mca-sub-heading" style={{ display: 'flex', alignItems: 'center', gap: '10px', borderLeft: 'none', paddingLeft: 0 }}>
                <span style={{ color: '#5a4ad1' }}>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="2" y="2" width="6" height="6" rx="1"></rect>
                    <rect x="9" y="9" width="6" height="6" rx="1"></rect>
                    <rect x="16" y="16" width="6" height="6" rx="1"></rect>
                    <line x1="5" y1="8" x2="5" y2="12"></line>
                    <line x1="5" y1="12" x2="9" y2="12"></line>
                    <line x1="12" y1="15" x2="12" y2="19"></line>
                    <line x1="12" y1="19" x2="16" y2="19"></line>
                  </svg>
                </span>
                Admission Process Flow Diagram
              </h3>

              <div className="mca-workflow-wrapper">
                <img
                  src="/images/program/WhatsApp-Image-2025-05-16-at-2.49.18-PM-550x550xc.jpeg"
                  alt="MCA Admission Workflow"
                  className="mca-workflow-image"
                />
              </div>
            </>
          )}

          {/* --- TAB 5: FEES DETAILS --- */}
          {activeTab === 'fees-details' && (
            <>
              <div className="mca-header">
                <div className="mca-info-icon-wrapper">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="mca-info-icon">
                    <rect x="2" y="6" width="20" height="12" rx="2"></rect>
                    <circle cx="12" cy="12" r="2"></circle>
                    <path d="M6 12h.01M18 12h.01"></path>
                  </svg>
                </div>
                <div className="mca-title">Fees Details (शुल्क विवरण)</div>
              </div>

              <p className="mca-text-content">
                Explore the MCA Working Professional course duration and fees at TIMSCDR here. The MCA Working Professional course fees, inclusive of various charges, ensure accessibility to quality education, with provisions for refunds and financial assistance available for eligible students. TIMSCDR, is one of the top 10 colleges for MCA in Mumbai with fees approved by FRA (Fee Regulating Authority). Below is the approved MCA Working Professional course fees for the A.Y. 2026-27 by Fee Regulating Authority, M.S. for 1st year Students.
              </p>

              <div className="mca-fees-table-container">
                <table className="mca-fees-table">
                  <thead>
                    <tr>
                      <th className="mca-fees-th">Particulars</th>
                      <th className="mca-fees-th" style={{ textAlign: 'right' }}>Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td className="mca-fees-td">Tuition fees<br />(शिक्षण शुल्क)</td>
                      <td className="mca-fees-td mca-fees-amount">72,727/-<br />(७२,७२७/ -)</td>
                    </tr>
                    <tr>
                      <td className="mca-fees-td">Development fees<br />(विकास शुल्क)</td>
                      <td className="mca-fees-td mca-fees-amount">7,273/-<br />(७,२७३/-)</td>
                    </tr>
                    <tr>
                      <td className="mca-fees-td">Caution Money / Deposit (Refundable) (सुरक्षा जमा शुल्क)</td>
                      <td className="mca-fees-td mca-fees-amount">₹ 3000/-<br />(३,०००/-)</td>
                    </tr>
                    <tr className="mca-fees-total-row">
                      <td className="mca-fees-total-label">Total Fees<br />(एकूण /कुल शुल्क)</td>
                  <td className="mca-fees-total-amount">83,000/-<br />(८३,०००/-)</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <h3 className="mca-sub-heading" style={{ borderLeftColor: '#5a4ad1', marginBottom: '15px', display: 'flex', alignItems: 'center', gap: '10px', paddingLeft: 0, borderLeft: 'none' }}>
                <span style={{ color: '#5a4ad1' }}>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <circle cx="11" cy="11" r="8"></circle>
                    <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                  </svg>
                </span>
                Fee Refund Policy
              </h3>

              <p className="mca-text-content" style={{ fontWeight: 600, marginBottom: "15px" }}>
                Refund of Tuition, Development fees after cancellation of admission :
              </p>

              <div className="mca-refund-box">
                <ul className="mca-refund-list">
                  <li className="mca-refund-item">
                    <div className="mca-refund-number">1</div>
                    <div className="mca-refund-text">
                      The refund of fees before cut-off date of admission shall be made within two days i.e. total fees minus the processing charges of Rs.1,000/-, or refund rule shall be as per the guidelines of the appropriate authorities or the State Government, as the case may be.
                    </div>
                  </li>
                  <li className="mca-refund-item">
                    <div className="mca-refund-number">2</div>
                    <div className="mca-refund-text">
                      If the admission is cancelled after the cut-off date of admission declared by the Competent authority, there shall be no refund.
                    </div>
                  </li>
                </ul>
              </div>
            </>
          )}

          {/* --- TAB 6: MODE OF PAYMENT --- */}
          {activeTab === 'mode-of-payment' && (
            <>
              <div className="mca-header">
                <div className="mca-info-icon-wrapper">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="mca-info-icon">
                    <rect x="2" y="5" width="20" height="14" rx="2"></rect>
                    <line x1="2" y1="10" x2="22" y2="10"></line>
                  </svg>
                </div>
                <div className="mca-title">Mode of Payment</div>
              </div>

              <div className="mca-payment-grid">
                <div className="mca-payment-col">
                  <div className="mca-payment-subhead">
                    <span style={{ color: '#5a4ad1', display: 'flex', alignItems: 'center' }}>
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <line x1="2" y1="10" x2="22" y2="10"></line>
                        <line x1="2" y1="20" x2="22" y2="20"></line>
                        <line x1="6" y1="10" x2="6" y2="20"></line>
                        <line x1="10" y1="10" x2="10" y2="20"></line>
                        <line x1="14" y1="10" x2="14" y2="20"></line>
                        <line x1="18" y1="10" x2="18" y2="20"></line>
                        <path d="M12 2l10 7H2L12 2z"></path>
                      </svg>
                    </span>
                    Financial Assistance
                  </div>
                  <div className="mca-payment-card">
                    <p className="mca-fin-text">
                      Financial Assistance is available as education loan for the bonafide students of institute from reputed banks. Interested students can utilize the benefit after getting admission to the course. Fee is chargeable per annum and is subject to revision from time to time as per notification from Fees Regulating Authority and University of Mumbai.
                    </p>
                  </div>
                </div>

                <div className="mca-payment-col">
                  <div className="mca-payment-subhead">
                    <span style={{ color: '#5a4ad1', display: 'flex', alignItems: 'center' }}>
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <rect x="3" y="3" width="7" height="7"></rect>
                        <rect x="14" y="3" width="7" height="7"></rect>
                        <rect x="14" y="14" width="7" height="7"></rect>
                        <rect x="3" y="14" width="7" height="7"></rect>
                      </svg>
                    </span>
                    Mode of Payment
                  </div>
                  <div className="mca-payment-card">
                    <div className="mca-qr-container">
                      <div className="mca-qr-placeholder">
                        <div className="mca-qr-inner">
                          <img
                            src="/images/icons/scan-fees-qr.jpg"
                            alt="Payment QR Code"
                            className="mca-qr-img"
                          />
                        </div>
                      </div>
                      <p className="mca-qr-text">
                        Pay fees via online payment portal, scan below QR code OR  Click Here
                      </p>
                      <button className="mca-pay-btn">
                        Click Here
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
      <ContactAdmissionsStrip onAppointmentClick={() => setShowForm(true)} />
      <Footer />
    </>
  );
};

export default MCAadmission;
